























































import {Component, Ref} from 'vue-property-decorator'
import productModule from '@/store/module/ProductModule';
import ThingModelApi from "@/module/thing/ThingModelApi";
import {Container} from "typescript-ioc";
import {EventType, Resource, ResourceType, RwFlag} from "@/model/ThingModel";
import {DataType, IntSpec} from '@/module/thing/DataSpec';
import {
  EventCreateForm,
  PropertyCreateForm,
  ResourcesUpsertForm,
  ResourceUpsertForm,
  ServiceCreateForm
} from "@/form/TmodelForm";
import {Form, TabPane} from "element-ui";
import {funRules} from '@/view/device-manage/product/fun-rules';

import CreateDialog from "@/component/Crud/create-dialog.vue";
import PropertyUpsertFormItems from "@/view/device-manage/product/property-upsert-form-items.vue";
import EventUpsertFormItems from "@/view/device-manage/product/event-upsert-form-items.vue";
import ServiceUpsertFormItems from "@/view/device-manage/product/service-upsert-form-items.vue";

@Component({
  components: {
    CreateDialog,
    PropertyUpsertFormItems,
    EventUpsertFormItems,
    ServiceUpsertFormItems,
  },
})
export default class FunCreateDialog extends CreateDialog {

  private thingModelApi = Container.get(ThingModelApi)

  @Ref()
  private createDialog!: CreateDialog

  @Ref()
  private createElFrom!: Form

  private EventType = EventType

  private propCreateForm =
      this.initPropertyCreateForm()

  private eventCreateForm =
      this.initEventCreateForm()

  private serviceCreateForm =
      this.initServiceCreateForm()

  private createForm: ResourceUpsertForm<Resource> =
      this.propCreateForm

  private ResourceType = ResourceType

  private rtype = ResourceType.PROPERTY

  private get rules() {
    return funRules(this.rtype)
  }

  initForms() {
    this.propCreateForm =
        this.initPropertyCreateForm()
    this.eventCreateForm =
        this.initEventCreateForm()
    this.serviceCreateForm =
        this.initServiceCreateForm()
  }

  async open() {
    await this.createDialog.open()
  }

  private beforeOpenCreateDialog() {
    this.createElFrom?.resetFields()
    this.initForms()
    this.changeCreateForm(this.activeResourceType)
  }

  private async createFun() {
    const valid = await this.createElFrom.validate()
    if (!valid) return

    const createForm = this.getCreateForm()
    const form = new ResourcesUpsertForm(productModule.active.id)
    switch (createForm.resourceType) {
      case ResourceType.PROPERTY:
        form.properties.push((createForm as PropertyCreateForm).toResource())
        break
      case ResourceType.EVENT:
        form.events.push((createForm as EventCreateForm).toResource())
        break
      case ResourceType.SERVICE:
        form.services.push((createForm as ServiceCreateForm).toResource())
        break
    }
    await this.thingModelApi.resourcesUpsert(form)
  }

  private getCreateForm() {
    return this.createForm
  }

  private activeResourceType = ResourceType.PROPERTY

  private handleTabsClick(tabPane: TabPane) {
    const resourceType = tabPane.name as ResourceType
    if (this.activeResourceType != resourceType) {
      this.changeCreateForm(resourceType)
      this.activeResourceType = resourceType
    }
  }

  private changeCreateForm(resourceType: ResourceType) {
    switch (resourceType) {
      case ResourceType.PROPERTY:
        this.createForm = this.propCreateForm
        break
      case ResourceType.EVENT:
        this.createForm = this.eventCreateForm
        break
      case ResourceType.SERVICE:
        this.createForm = this.serviceCreateForm
        break
    }
  }

  private initPropertyCreateForm(): PropertyCreateForm {
    const form = new PropertyCreateForm()
    form.dataType = DataType.INT
    form.dataSpecs = [new IntSpec()]
    form.rwFlag = RwFlag.READ_WRITE
    return form
  }

  private initEventCreateForm(): EventCreateForm {
    return new EventCreateForm(EventType.INFO)
  }

  private initServiceCreateForm(): ServiceCreateForm {
    return new ServiceCreateForm()
  }
}
